import { SearchOption } from './search-option';

export class SearchParams {
  constructor(public searchText: string, public searchOption: SearchOption) {}
}
